import axios from "axios";
import { useEffect, useState } from "react";
import background from "../../assets/images/background.png";
import { DASHBOARD_ROUTE, HOME_ROUTE } from "../../routes";
import authServices from "../../services/authServices";
import dataProvider from "../../services/dataProvider";
import qs from "qs" ;
import { isAuthenticated } from "../../services/firebase";

const FreeAlertBanner = ({ history, ...props }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=>{
        setIsLoading(false);

        if(isAuthenticated()){
            if(!props.location.state) {
                history.replace(DASHBOARD_ROUTE);
            }
        } else {
            history.replace(HOME_ROUTE);
        }

    },[]);

    function handleSubmit(e) {
        e.preventDefault();

        setIsLoading(true);

        let data = JSON.stringify(props.location.state);
        
        fetch(dataProvider.baseUrl+"addNominatedInchargeToMailingList",{
            method:"POST",
            body: data,
            headers : {
                token : authServices.getToken()
            }
        })
        .then(res => res.json())
        .then(result => {
            // console.log("result",result);
            setIsLoading(false);
            history.replace(DASHBOARD_ROUTE);
        }).catch((err)=>{
            console.error(err);
            setIsLoading(false);
        })
    }

    function handleCancel() {
        history.replace(DASHBOARD_ROUTE);
    }

    return (
        <div
            id="free-alert-banner"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3"></div>
                <h1 className="text-center text-light mt-5">Subscribe to Free Alerts</h1>
                <h5 className="text-center text-light mt-5">Do you want to subscribe to our free alerts service</h5>
                <form onSubmit={handleSubmit}>
                    <div className="d-flex justify-content-center mt-5">
                        <button
                            onClick={handleCancel}
                            type="button"
                            className="btn btn-outline-light rounded-pill px-5 text-btn"
                            style={{ height: "3rem" }}
                        >
                            No
                        </button>

                        {isLoading ? (
                            <button
                                style={{ height: "3rem" }}
                                className="d-flex ms-3 align-items-center btn btn-outline-light rounded-pill px-4 text-btn"
                                disabled
                            >
                                Subscribing...
                                <div className="spinner-border spinner-border-sm ms-4" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </button>
                        ) : (
                            <button
                                className="btn btn-outline-light rounded-pill px-5 text-btn ms-3"
                                style={{ height: "3rem" }}
                            >
                                Yes
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FreeAlertBanner;
